export const siteConfig = {
  contact: {
    phone: '+90 507 080 8888',
    email: 'info@dentawista.com',
    whatsappUrl: 'https://wa.me/905070808888',
  },
} as const;
